import { faBriefcase, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import './Banner.css';
import designImg from '../../Images/design.webp';
import { useAuthState } from 'react-firebase-hooks/auth';
import auth from '../../firebase.init';
import Loading from '../../Shared/Loading';



const Banner = () => {

    const [user, loading] = useAuthState(auth);
    const [myself, setMyself] = useState([]);

    const email = user?.email;

    useEffect(() => {
        const url = `https://stark-wildwood-35883.herokuapp.com/myself`;
        fetch(url)
            .then(res => res.json())
            .then(data => setMyself(data))
    }, [email])

    const me = myself?.find((e) => e?.email === 'coder@webdeveloper.com');

    if (loading) {
        return <Loading />
    }

    return (
        <div className="hero relative min-h-screen" id='banner'>
            <div className="hero-content  flex-col md:flex-row-reverse  lg:flex-row-reverse">
                <div className=' relative lg:w-1/2 md:w-1/2     py-4 ' >
                    <div
                        data-aos="zoom-in"
                        data-aos-anchor="#example-anchor"
                        data-aos-offset="500"
                        data-aos-duration="1000"
                    >
                        {me?.img && <img src={me?.img} alt="Profile_Picture" className=' border-3 border-primary profile_Shadow rounded-full w-80 md:w-4/6 mx-auto mb-5 ' />}
                    </div>
                    <img src={designImg} className="animate-bounce  ease-in absolute bottom-10 lg:left-5 lg:w-32 md:w-24 w-20 " alt="Design" />
                </div>
                <div className='lg:w-1/2 md:w-1/2  md:text-left text-center md:px-8' >
                    <h1 className="text-3xl font-bold  text-black"
                        data-aos="fade-right"
                        data-aos-anchor="#example-anchor"
                        data-aos-offset="500"
                        data-aos-duration="800"
                    ><span className='text-green-500'>Hello!</span> I'm</h1>
                    <h1 className="text-4xl pt-2 font-bold text-black"
                        data-aos="fade-right"
                        data-aos-anchor="#example-anchor"
                        data-aos-offset="500"
                        data-aos-duration="1300"
                    >Md. Shakil Ahmed</h1>
                    {me?.title && <h1 className="text-2xl pt-2 font-bold text-primary "
                        data-aos="fade-right"
                        data-aos-anchor="#example-anchor"
                        data-aos-offset="500"
                        data-aos-duration="1800"
                    >{me?.title}</h1>}
                    {me?.description && <p className="py-2 text-lg text-gray-500 md:p-0 p-2 mb-2"
                        data-aos="fade-right"
                        data-aos-anchor="#example-anchor"
                        data-aos-offset="500"
                        data-aos-duration="2300"
                    > {me?.description}</p>}
                    <div className='flex md:justify-start justify-center'
                        data-aos="fade-up"
                        data-aos-anchor="#example-anchor"
                        data-aos-offset="500"
                        data-aos-duration="2500"
                    >
                        <a href="#contact"   rel="noopener" className="btn custom_shadow btn-primary mr-3 text-white"
                        > Contact Me <FontAwesomeIcon className='ml-2' icon={faEnvelope} /> </a>
                        <a target="_blank" rel="noopener" className="btn custom_shadow btn-secondary text-white" href="https://www.linkedin.com/in/codermdshakil/" target="_blank" >Hire Me <FontAwesomeIcon className='ml-2' icon={faBriefcase} /> </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Banner;